module.exports = __webpack_public_path__ + "static/media/037-jamaica.fb3bcbba.svg";